// extracted by mini-css-extract-plugin
export default {"formInput":"FormInput_formInput__pFoIf","formInputError":"FormInput_formInputError__P7BhU FormInput_formInput__pFoIf"};